import Analytics from '@opencare/analytics';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { FlexCol } from 'common/styles/oc-styled-components';
import { useAnalyticsService } from 'services/AnalyticsService';

import {
  GtmDataLayerEvent,
  trackGtmDataLayerEvent,
} from '../../../../utils/analytics';
import {
  PrimaryButton,
  Subtitle,
  Title,
} from '../../../common/styled-components';
import { useFunnelStorage } from '../../storage/Storage';
import { generateStepAnalytics, STEP_KEY } from '../../utils';

import { ButtonWrapper, WelcomeStepContainer } from './styled-components';

const analytics = new Analytics();

const Welcome = ({ position, moveToNextStep, funnelHasBeenReset }) => {
  const history = useHistory();
  const storage = useFunnelStorage();

  const analyticsService = useAnalyticsService();

  const location = storage.get(STEP_KEY.LOCATION);
  const locality = location?.address?.locality || 'your city';

  useEffect(() => {
    const userUsedBrowserButtons = history.action === 'POP';

    // If we land on Welcome without navigating using the browser buttons,
    // Or if any other step has been completed, skip this step
    if (!userUsedBrowserButtons && (funnelHasBeenReset || !isFirstStep())) {
      completeStep();
      return;
    }

    analytics.trackPageView({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_welcome',
      ...generateStepAnalytics(position, storage),
      ...analyticsService.analyticsData,
    });
  }, []);

  const handleClick = (_value, index) => {
    analytics.trackClick({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_welcome',
      name: 'wizard',
      section: 'welcome',
      position: [index + 1],
      ...generateStepAnalytics(position, storage),
    });

    completeStep();
  };

  const isFirstStep = () => {
    // Get a copy of the progress and remove location data as it might be filled from homepage
    const progress = {
      ...storage.progress,
    };
    delete progress[STEP_KEY.LOCATION];

    return !Object.keys(progress).length;
  };

  const completeStep = () => {
    storage.save(STEP_KEY.WELCOME, true, true);
    moveToNextStep();
  };

  trackGtmDataLayerEvent(GtmDataLayerEvent.SEARCH_QUESTION_WELCOME_REACHED);

  return (
    <WelcomeStepContainer>
      <div className="main-content">
        <Title id="title">
          <span role="img" aria-label="hello">
            👋
          </span>{' '}
          Welcome to Opencare!
        </Title>
        <Subtitle>
          Let's find your perfect dentist in
          {` ${locality}. `}
          We're going to narrow down and personalize your results by asking you
          a few quick questions. It'll take less than 30 seconds!
        </Subtitle>
        <ButtonWrapper>
          <FlexCol gap="15px">
            <PrimaryButton data-testid="welcome-start" onClick={handleClick}>
              Start!
            </PrimaryButton>
          </FlexCol>
        </ButtonWrapper>
      </div>
    </WelcomeStepContainer>
  );
};

Welcome.defaultProps = {
  position: '',
  funnelHasBeenReset: false,
};

Welcome.propTypes = {
  position: PropTypes.string,
  moveToNextStep: PropTypes.func.isRequired,
  funnelHasBeenReset: PropTypes.bool,
};

export default Welcome;
